import React from 'react';
import Card from '../../ui/Card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
const EfficiencyRankingChart: React.FC = () => {
  const data = [{
    channel: 'BTL',
    costPerConversion: 1850,
    conversions: 615,
    color: '#10b981',
    rank: 1
  }, {
    channel: 'Digital',
    costPerConversion: 2240,
    conversions: 597,
    color: '#3b82f6',
    rank: 2
  }, {
    channel: 'TV',
    costPerConversion: 2950,
    conversions: 280,
    color: '#8b5cf6',
    rank: 3
  }, {
    channel: 'Print',
    costPerConversion: 3420,
    conversions: 134,
    color: '#f59e0b',
    rank: 4
  }, {
    channel: 'Outdoor',
    costPerConversion: 4580,
    conversions: 83,
    color: '#ef4444',
    rank: 5
  }];
  return <Card className="p-6" data-id="element-7425">
      <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-7426">
        Channel Efficiency Ranking
      </h3>
      <p className="text-sm text-gray-600 mb-4" data-id="element-7427">
        Cost per conversion by channel (₹) - Lower is better
      </p>
      <ResponsiveContainer width="100%" height={300} data-id="element-7428">
        <BarChart data={data} layout="horizontal" data-id="element-7429">
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-7430" />
          <XAxis type="number" tick={{
          fontSize: 12
        }} label={{
          value: 'Cost per Conversion (₹)',
          position: 'insideBottom',
          offset: -5,
          fontSize: 11
        }} data-id="element-7431" />
          <YAxis dataKey="channel" type="category" width={80} tick={{
          fontSize: 12
        }} data-id="element-7432" />
          <Tooltip contentStyle={{
          backgroundColor: 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '8px'
        }} formatter={(value: number) => `₹${value.toLocaleString()}`} data-id="element-7433" />
          <Bar dataKey="costPerConversion" name="Cost per Conversion" radius={[0, 8, 8, 0]} data-id="element-7434">
            {data.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-7435" />)}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-7436">
        <div className="space-y-3" data-id="element-7437">
          {data.map((channel, index) => <div key={index} className="flex items-center justify-between text-sm" data-id="element-7438">
              <div className="flex items-center" data-id="element-7439">
                <div className="w-8 h-8 rounded-full flex items-center justify-center text-white font-bold mr-3" style={{
              backgroundColor: channel.color
            }} data-id="element-7440">
                  {channel.rank}
                </div>
                <span className="font-medium text-gray-800" data-id="element-7441">
                  {channel.channel}
                </span>
              </div>
              <div className="flex items-center space-x-4" data-id="element-7442">
                <div className="text-right" data-id="element-7443">
                  <div className="text-xs text-gray-500" data-id="element-7444">Cost/Conv</div>
                  <div className="font-bold text-gray-900" data-id="element-7445">
                    ₹{channel.costPerConversion.toLocaleString()}
                  </div>
                </div>
                <div className="text-right" data-id="element-7446">
                  <div className="text-xs text-gray-500" data-id="element-7447">Conversions</div>
                  <div className="font-semibold text-gray-700" data-id="element-7448">
                    {channel.conversions}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
      <div className="mt-4 p-4 bg-blue-50 rounded-lg border border-blue-200" data-id="element-7449">
        <div className="flex items-start" data-id="element-7450">
          <div className="flex-shrink-0 w-2 h-2 rounded-full bg-blue-600 mt-1.5 mr-2" data-id="element-7451" />
          <div className="text-sm text-blue-800" data-id="element-7452">
            <span className="font-semibold" data-id="element-7453">Efficiency Leader:</span> BTL
            activities most efficient at ₹1,850 per conversion, delivering 615
            conversions. Outdoor advertising least efficient at ₹4,580 per
            conversion - consider reallocation.
          </div>
        </div>
      </div>
    </Card>;
};
export default EfficiencyRankingChart;